import React from 'react';
import MessageDisplay from '../MessageDisplay';
import StaffPageShell from '../StaffPageShell';

const DATE_INPUT_STYLE = `
        input[type="date"]:not([value]):not([value=""])::-webkit-datetime-edit-text,
        input[type="date"]:not([value]):not([value=""])::-webkit-datetime-edit-month-field,
        input[type="date"]:not([value]):not([value=""])::-webkit-datetime-edit-day-field,
        input[type="date"]:not([value]):not([value=""])::-webkit-datetime-edit-year-field,
        input[type="date"][value=""]::-webkit-datetime-edit-text,
        input[type="date"][value=""]::-webkit-datetime-edit-month-field,
        input[type="date"][value=""]::-webkit-datetime-edit-day-field,
        input[type="date"][value=""]::-webkit-datetime-edit-year-field {
          color: transparent !important;
        }
        input[type="date"]:not([value=""]):not(:invalid)::-webkit-datetime-edit-text,
        input[type="date"]:not([value=""]):not(:invalid)::-webkit-datetime-edit-month-field,
        input[type="date"]:not([value=""]):not(:invalid)::-webkit-datetime-edit-day-field,
        input[type="date"]:not([value=""]):not(:invalid)::-webkit-datetime-edit-year-field {
          color: var(--color-text);
        }
`;

/**
 * Shared page chrome + form wrapper for admin add-user flow.
 */
const AdminUserFormShell = ({
  pageTitle,
  pageSubtitle,
  formTitle,
  message,
  messageId,
  onSubmit,
  children,
  afterForm = null,
  formClassName = 'profile-card theme-animate p-8 w-full',
}) => {
  return (
    <>
      <style>{DATE_INPUT_STYLE}</style>
      <StaffPageShell title={pageTitle} subtitle={pageSubtitle}>
        <form onSubmit={onSubmit} className={formClassName}>
          <h2 className="text-xl font-bold mb-6 theme-text-gradient">{formTitle}</h2>
          <MessageDisplay message={message} id={messageId} />
          {children}
        </form>
        {afterForm}
      </StaffPageShell>
    </>
  );
};

export default AdminUserFormShell;
